export default __webpack_public_path__ + "static/media/appModeMenu.df9ef389.png";